import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { userDataType } from "../pages/Login";
import Header, { menuFoldState } from "./Layout/Header";
import SideNavigation from "./Layout/SideNavigation";

interface SMainContent {
  isFold?: boolean;
}

export default function Layout() {
  const fold = useRecoilValue(menuFoldState);
  const navigate = useNavigate();

  const user = useRecoilValue(userDataType);

  const getCookieValue = (key: string) => {
    let cookieKey = key + "=";
    let result = "";
    const cookieArr = document.cookie.split(";");

    for (let i = 0; i < cookieArr.length; i++) {
      if (cookieArr[i][0] === " ") {
        cookieArr[i] = cookieArr[i].substring(1);
      }

      if (cookieArr[i].indexOf(cookieKey) === 0) {
        result = cookieArr[i].slice(cookieKey.length, cookieArr[i].length);
        return result;
      }
    }
    return result;
  };

  const cookieSid = getCookieValue("sid");

  useEffect(() => {
    if (!cookieSid) {
      navigate("/login");
    }
  }, [navigate, cookieSid]);

  if (cookieSid)
    return (
      <>
        <SideNavigation />
        <Header />

        <MainContent isFold={fold}>
          <Outlet />
        </MainContent>
      </>
    );
  else return <div>Redirecting to Login...</div>;
}

const MainContent = styled.main<SMainContent>`
  position: relative;
  left: ${({ isFold }) => (isFold ? 0 : 240)}px;
  width: ${({ isFold }) => (isFold ? "100%" : "calc(100% - 240px)")};
  min-height: 100vh;
  height: 100%;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 104px 40px 60px 40px;
  transition: left 0.2s ease;
`;
